import SvgIcon from "@mui/material/SvgIcon";
import Icons from "../assets/icons/icons.svg";
import PropTypes from "prop-types";

const CustomIcon = (props) => {
  return (
  <SvgIcon {...props}>
    <use xlinkHref={`${Icons}#icon-${props.name}`} />
  </SvgIcon>
)};

CustomIcon.propTypes = {
  name: PropTypes.string.isRequired,
  color: PropTypes.string,
  size: PropTypes.number,
};

export default CustomIcon;
